import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMember } from "../api/admin";
import { DeleteAdmin } from "../types/types";
import { useSnackbar } from "notistack";

const useDeleteMember = ({ idx }: DeleteAdmin, closeModal: () => void) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: () => deleteMember({ idx }),
    onSuccess: () => {
      // console.log(data);
      queryClient.invalidateQueries({ queryKey: ["Member"] });
      enqueueSnackbar(`사용자 계정 삭제 성공`, {
        variant: "success",
      });

      closeModal();
    },
  });
  return mutation;
};

export default useDeleteMember;
